
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["toggleable", "icon"]

    connect() {
        this.element.classList.add("w-64")
    }

    toggle() {
        this.element.classList.toggle("w-16")
        this.element.classList.toggle("w-64")

        this.toggleableTargets.forEach(target => {
            target.classList.toggle("hidden")
        })

        if (this.element.classList.contains("w-16")) {
            this.iconTarget.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>`
        } else {
            this.iconTarget.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>`
        }
    }
}
